module.exports = __webpack_public_path__ + "img/Flag_of_Luxembourg.a3a2e106.svg";